/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import App from './src/components/App.js'

import { createStore } from 'redux'
import { Provider } from 'react-redux'
import rootReducer from './src/reducers'

let store = null

const getStore = () => {
    if (!store) {
        try {
            store = createStore(rootReducer)
        } catch (error) {
            console.error('Failed to create Redux store:', error)
            store = createStore(() => ({}))
        }
    }
    return store
}

class PersonalSettings extends Component {
    /**
     * @param {object} props
     */
    constructor (props) {
        super(props)
        this.store = getStore()
    }

    /**
     * @returns {JSX.Element}
     */
    render () {
        return (
            <Provider store={this.store}>
                <App
                    extension={this.props.extension}
                    standalone={this.props.standalone}
                    onLoaded={this.props.onLoaded}
                    origin={this.props.origin}
                    basePathname={this.props.basePathname}
                    setHasChange={this.props.setHasChange}
                    routeProps={this.props.routeProps}
                />
            </Provider>
        )
    }
}

export default PersonalSettings
